import { useEffect, useState } from "react";

import { startCase } from "lodash";

import { Select } from "@alpacahq/ui/old";

type FilterProps<T> = {
  field: keyof T;
  fieldLabel?: string;
  options: string[];
  optionsLabels?: string[];
  setter: (value: Record<string, string>) => void;
  defaultValue?: string;
};

export const Filter = <T,>({
  field,
  fieldLabel,
  options,
  optionsLabels,
  setter,
  defaultValue,
}: FilterProps<T>) => {
  const [value, setValue] = useState(defaultValue || "all");

  // biome-ignore lint/correctness/useExhaustiveDependencies: value is the trigger. field and setter are props (setter is typically an inline arrow that writes parent state), so listing setter would loop: the effect calls setter, the parent re-renders with a new setter, and the effect fires again.
  useEffect(() => {
    setter({ [field]: value });
  }, [value]);

  return (
    <div className="flex min-w-fit items-center whitespace-nowrap rounded bg-gray-100 pl-4">
      <div className="mr-4 text-gray-700 text-sm">
        {fieldLabel || startCase(String(field))}
      </div>
      <Select
        value={value || "all"}
        onChange={setValue}
        options={options.map((option, index) => ({
          value: option,
          label: optionsLabels?.at(index) || startCase(option),
        }))}
      />
    </div>
  );
};

export default Filter;
